import { useAppContext } from 'context/AppProvider'
import React from 'react'

import { SortType } from 'types'

import {
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  Menu,
  Flex,
  Button,
  Center,
  useMediaQuery,
  FlexProps
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { VscChevronDown, VscChevronUp } from 'react-icons/vsc'

const sortOption: SortType[] = ['updated_at:desc', 'published_at:desc', 'price:asc', 'price:desc']

type SortProps = {
  totalResults?: number | null
  limit: number | undefined
  start: number | undefined
} & FlexProps

const Sort: React.FC<SortProps> = ({ totalResults, limit, start, ...rest }) => {
  const { setSortType, sortType } = useAppContext()
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  const { t } = useTranslation()
  const name = {
    'updated_at:desc': t('search_results.sort_by_default'),
    'published_at:desc': t('search_results.sort_by_most_recent'),
    'price:asc': t('search_results.sort_by_price_low'),
    'price:desc': t('search_results.sort_by_price_high')
  }

  return (
    <Flex w="100%" align="center" mb={4} justify="space-between" {...rest}>
      <Menu placement="auto">
        {({ isOpen }) => (
          <>
            <MenuButton
              as={Button}
              width={['100%', 'auto']}
              fontSize="x-small"
              fontWeight="extrabold"
              rightIcon={isOpen ? <VscChevronUp /> : <VscChevronDown />}
            >
              {t('search_results.sort_by')} {name[sortType]}
            </MenuButton>
            <MenuList minWidth="240px">
              <MenuOptionGroup
                onChange={(value) => setSortType(value as SortType)}
                defaultValue={sortType}
                type="radio"
              >
                {sortOption.map((opt, idx) => (
                  <MenuItemOption key={idx} fontSize="xs" fontWeight="semibold" value={opt}>
                    {name[opt]}
                  </MenuItemOption>
                ))}
              </MenuOptionGroup>
            </MenuList>
          </>
        )}
      </Menu>

      {!isTabletOrMobile && (
        <Center fontWeight="bold" fontSize="x-small">
          {t('search_results.showing')} : {start} - {(limit || 0) + (start || 0)}{' '}
          {t('search_results.of')} {totalResults}
        </Center>
      )}
    </Flex>
  )
}

export default Sort
